


























import { Vue, Mixins, Component, Ref } from 'vue-property-decorator';
import { AxApp } from '@/mixins';
import { AppFrame } from '@/enums';
import AxFrame from '@/pages/AxFrame.vue';
import AxLogin from '@/pages/AxLogin.vue';
import { AxStorage } from './storage';

@Component
export default class App extends Mixins(AxApp) {
  @Ref()
  axFrame!: AxFrame;

  @Ref()
  axLogin!: AxLogin;

  mounted() {
    setTimeout(() => {
      const dialogs = Object.keys(
        ((Vue as unknown) as { options: { components: { [key: string]: unknown } } }).options
          .components
      ).filter(x => {
        const lastIndex = x.lastIndexOf('Dialog');
        if (lastIndex === -1) return false;
        if (lastIndex !== x.length - 6) return false;
        return true;
      });

      this.dialogList = dialogs;
      console.log(this.dialogList);
    }, 0);
  }

  async created() {
    if (this.isDevelopment) {
      this.initDev();
    } else {
      this.initProd();
    }
  }

  // 개발환경일때 로그인 스킵
  async initDev() {
    const skipLogin = AxStorage.skipLogin;

    this.setAppFrame(AppFrame.Login);
    if (skipLogin) {
      await this.$nextTick();
      this.axLogin.login('test', '1234');
    } else {
      this.setAppFrame(AppFrame.Login);
    }
  }

  async initProd() {
    this.setAppFrame(AppFrame.Login);
  }
}
